import appSync from '@/_services/appsync.service.js'
import gql from 'graphql-tag'

export const userService = {
  listUsers,
  listContacts,
  setUserRole,
  setUserName,
  setUserPosition,
  setUserDepartment,
  setUserBio,
  addUserPhone,
  removeUserPhone,
  addUserEmail,
  removeUserEmail,
  setContactName,
  setContactPosition,
  setContactDepartment,
  addContactPhone,
  removeContactPhone,
  addContactEmail,
  removeContactEmail,
  addContactPerson,
  removeContactPerson,
  getUserRoleTypeEnum
}
/** QUERIES */
const LIST_USERS = gql`query listUsers ($input: ListUsersInput!) {
  listUsers(input: $input) {
    users {
      id
      name {
        given
        middle
        family
      }
      bio
      position
      department
      role
      status
      contacts {
        type
        value
        public
      }
    }
  }
}`
const LIST_CONTACTS = gql`query listContacts ($input: ListContactsInput!) {
  listContacts(input: $input) {
    contacts {
      id
      name {
        given
        middle
        family
      }
      department
      position
      contacts {
        type
        value
        public
      }
    }
  }
}`

async function listUsers ({ organizationID }) {
  try {
    const response = await appSync.query({
      query: LIST_USERS,
      variables: {
        input: {
          organization: organizationID
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.listUsers.users
  } catch (error) {
    return Promise.reject(error)
  }
}
async function listContacts ({ organizationID }) {
  try {
    const response = await appSync.query({
      query: LIST_CONTACTS,
      variables: {
        input: {
          organization: organizationID
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.listContacts.contacts
  } catch (error) {
    return Promise.reject(error)
  }
}

/** Mutations */
const SET_USER_ROLE = gql`mutation setUserRole ($input: SetUserRoleInput!) {
  setUserRole(input: $input) {
    err
  }
}`
const SET_USER_NAME = gql`mutation setUserName ($input: SetUserNameInput!) {
  setUserName(input: $input) {
    err
  }
}`
const SET_USER_POSITION = gql`mutation setUserName ($input: SetUserPositionInput!) {
  setUserPosition(input: $input) {
    err
  }
}`
const SET_USER_DEPARTMENT = gql`mutation setUserName ($input: SetUserDepartmentInput!) {
  setUserDepartment(input: $input) {
    err
  }
}`
const SET_USER_BIO = gql`mutation setUserName ($input: SetUserBioInput!) {
  setUserBio(input: $input) {
    err
  }
}`
const ADD_USER_PHONE = gql`mutation addUserPhone ($input: AddUserPhoneInput!) {
  addUserPhone(input: $input) {
    err
  }
}`
const REMOVE_USER_PHONE = gql`mutation removeUserPhone ($input: RemoveUserPhoneInput!) {
  removeUserPhone(input: $input) {
    err
  }
}`
const ADD_USER_EMAIL = gql`mutation addUserEmail ($input: AddUserEmailInput!) {
  addUserEmail(input: $input) {
    err
  }
}`
const REMOVE_USER_EMAIL = gql`mutation removeUserEmail ($input: RemoveUserEmailInput!) {
  removeUserEmail(input: $input) {
    err
  }
}`
const SET_CONTACT_NAME = gql`mutation setContactName ($input: SetContactNameInput!) {
  setContactName(input: $input) {
    err
  }
}`
const SET_CONTACT_POSITION = gql`mutation setContactPosition ($input: SetContactPositionInput!) {
  setContactPosition(input: $input) {
    err
  }
}`
const SET_CONTACT_DEPARTMENT = gql`mutation setContactDepartment ($input: SetContactDepartmentInput!) {
  setContactDepartment(input: $input) {
    err
  }
}`
const ADD_CONTACT_PHONE = gql`mutation addContactPhone ($input: AddContactPhoneInput!) {
  addContactPhone(input: $input) {
    err
  }
}`
const REMOVE_CONTACT_PHONE = gql`mutation removeContactPhone ($input: RemoveContactPhoneInput!) {
  removeContactPhone(input: $input) {
    err
  }
}`
const ADD_CONTACT_EMAIL = gql`mutation addContactEmail ($input: AddContactEmailInput!) {
  addContactEmail(input: $input) {
    err
  }
}`
const REMOVE_CONTACT_EMAIL = gql`mutation removeContactEmail ($input: RemoveContactEmailInput!) {
  removeContactEmail(input: $input) {
    err
  }
}`
const ADD_CONTACT_PERSON = gql`mutation addContactPerson ($input: AddContactPersonInput!) {
  addContactPerson(input: $input) {
    contactID
  }
}`
const REMOVE_CONTACT_PERSON = gql`mutation removeContactPerson ($input: RemoveContactPersonInput!) {
  removeContactPerson(input: $input) {
    err
  }
}`

async function setUserRole ({ userID, role }) {
  try {
    const response = await appSync.mutate({
      mutation: SET_USER_ROLE,
      variables: {
        input: {
          userID,
          role
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.addContactPerson
  } catch (error) {
    return Promise.reject(error)
  }
}

async function setUserName ({ userID, given, middle, family }) {
  try {
    const response = await appSync.mutate({
      mutation: SET_USER_NAME,
      variables: {
        input: {
          userID,
          given,
          middle,
          last: family
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

async function setUserPosition ({ userID, position }) {
  try {
    const response = await appSync.mutate({
      mutation: SET_USER_POSITION,
      variables: {
        input: {
          userID,
          position
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

async function setUserDepartment ({ userID, department }) {
  try {
    const response = await appSync.mutate({
      mutation: SET_USER_DEPARTMENT,
      variables: {
        input: {
          userID,
          department
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

async function setUserBio ({ userID, bio }) {
  try {
    const response = await appSync.mutate({
      mutation: SET_USER_BIO,
      variables: {
        input: {
          userID,
          bio
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function addUserPhone ({ userID, phone }) {
  try {
    const response = await appSync.mutate({
      mutation: ADD_USER_PHONE,
      variables: {
        input: {
          userID,
          phone
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

async function removeUserPhone ({ userID, phone }) {
  try {
    const response = await appSync.mutate({
      mutation: REMOVE_USER_PHONE,
      variables: {
        input: {
          userID,
          phone
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function addUserEmail ({ userID, email }) {
  try {
    const response = await appSync.mutate({
      mutation: ADD_USER_EMAIL,
      variables: {
        input: {
          userID,
          email
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

async function removeUserEmail ({ userID, email }) {
  try {
    const response = await appSync.mutate({
      mutation: REMOVE_USER_EMAIL,
      variables: {
        input: {
          userID,
          email
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

//**CONTACTS MUTATIONS */

async function setContactName ({ contactID, given, middle, family }) {
  try {
    const response = await appSync.mutate({
      mutation: SET_CONTACT_NAME,
      variables: {
        input: {
          contactID,
          given,
          middle,
          last: family
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setContactPosition ({ contactID, position}) {
  try {
    const response = await appSync.mutate({
      mutation: SET_CONTACT_POSITION,
      variables: {
        input: {
          contactID,
          position
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setContactDepartment ({ contactID, department}) {
  try {
    const response = await appSync.mutate({
      mutation: SET_CONTACT_DEPARTMENT,
      variables: {
        input: {
          contactID,
          department
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

async function addContactPhone ({ contactID, phone }) {
  try {
    const response = await appSync.mutate({
      mutation: ADD_CONTACT_PHONE,
      variables: {
        input: {
          contactID,
          phone
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

async function removeContactPhone ({ contactID, phone }) {
  try {
    const response = await appSync.mutate({
      mutation: REMOVE_CONTACT_PHONE,
      variables: {
        input: {
          contactID,
          phone
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

async function addContactEmail ({ contactID, email }) {
  try {
    const response = await appSync.mutate({
      mutation: ADD_CONTACT_EMAIL,
      variables: {
        input: {
          contactID,
          email
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)

  }
}
async function removeContactEmail ({ contactID, email }) {
  try {
    const response = await appSync.mutate({
      mutation: REMOVE_CONTACT_EMAIL,
      variables: {
        input: {
          contactID,
          email
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)

  }
}

async function addContactPerson ({ organizationID, name, email, phone }) {
  try {
    const response = await appSync.mutate({
      mutation: ADD_CONTACT_PERSON,
      variables: {
        input: {
          organizationID,
          name,
          email,
          phone
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.addContactPerson
  } catch (error) {
    return Promise.reject(error)
  }
}
async function removeContactPerson ({ contactID }) {
  try {
    const response = await appSync.mutate({
      mutation: REMOVE_CONTACT_PERSON,
      variables: {
        input: {
          contactID
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}


/** ENUM */

const GET_USER_ROLE_TYPE_ENUMS = gql`query {
  __type(name: "Roles") {
     name
     enumValues {
       name
     }
   }
 }`
async function getUserRoleTypeEnum () {
  try {
    const response = await appSync.query({
      query: GET_USER_ROLE_TYPE_ENUMS,
      fetchPolicy: 'cache'
    })
    return response.data.__type.enumValues
  } catch (error) {
    return Promise.reject(error)
  }
}
